import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { PaymentMethodDropdown } from 'src/domains/players/webview/components/WithdrawAndDeposit/components/paymentMethodDropdown/PaymentMethodDropdown';
import { WithdrawProcedureBtnWrapper } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdraw/WithdrawProcedure.style';
import { observer } from 'src/utils/mobx-react';
import { PaymentMethodDropdownState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/PaymentMethodDropdown.state';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { WithdrawFormState } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/WithdrawFormState';
import { useCommon } from 'src/domains/common/Common';
import { NewPaymentMethodDropdown } from 'src/domains/players/webview/components/WithdrawAndDeposit/components/newPaymentMethodDropdown/NewPaymentMethodDropdown';

interface WithdrawCardSegmentPropType {
    state: WithdrawFormState;
    paymentMethodDropdownState: PaymentMethodDropdownState;
}

export const WithdrawCardSegment = observer(
    'WithdrawCardSegment',
    ({ state, paymentMethodDropdownState }: WithdrawCardSegmentPropType) => {
        const common = useCommon();
        return (
            <>
                {common.features.withdrawDropdownNew === true ? (
                    <NewPaymentMethodDropdown
                        key='new-payment-method-dropdown'
                        label={
                            <I18n
                                langKey='account.top-up.payment-method-dropdown.select.label'
                                defaultText='Select Card'
                            />
                        }
                        paymentMethodDropdownState={paymentMethodDropdownState}
                    />
                ) : (
                    <PaymentMethodDropdown
                        key='payment-method-dropdown'
                        label={
                            <I18n
                                langKey='account.top-up.payment-method-dropdown.select.label'
                                defaultText='Select Card'
                            />
                        }
                        options={paymentMethodDropdownState.savedPaymentMethods}
                        value={paymentMethodDropdownState.paymentMethodsValue}
                        onChangeCB={paymentMethodDropdownState.handlePaymentSelectChange}
                        refreshPaymentMethods={paymentMethodDropdownState.refreshPaymentMethods}
                    />
                )}
                {state.withdrawErrorMessage === null ? null : (
                    <Messages
                        type='error'
                        message={state.withdrawErrorMessage}
                    />
                )}
                <WithdrawProcedureBtnWrapper
                    size='large'
                    onClick={state.submitWithdrawForm}
                    disabled={state.isBtnDisabled || state.isWithdrawFormSubmitting}
                    dataTest='withdraw-procedure-btn'
                >
                    <I18n
                        langKey='account.withdraw.submit.label'
                        defaultText='Withdraw'
                    />
                </WithdrawProcedureBtnWrapper>
            </>
        );
    }
);
